import $ from "jquery";
import "bootstrap";
import "popper.js";

import "./custom/scripts";
import "./modules/navBar";
import "./custom/jqScript";
import "./custom/swiper";
import "./custom/form";


